module.exports = __webpack_public_path__ + "static/NOI4-d499a5b4dbb8459dfc7e44ad3d7d9c49.jpg";